import { render, staticRenderFns } from "./ManualWithdraw.vue?vue&type=template&id=bfd9ba22&scoped=true&"
import script from "./ManualWithdraw.vue?vue&type=script&lang=js&"
export * from "./ManualWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./ManualWithdraw.vue?vue&type=style&index=0&id=bfd9ba22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd9ba22",
  null
  
)

export default component.exports